import { Component, ViewChild } from '@angular/core';
import { Platform,Nav } from 'ionic-angular';
import 'rxjs/add/operator/toPromise';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import { HomePage } from '../pages/home/home';
import {  ItemDetailComponent} from '../components/item-detail/item-detail'
declare var wx: any;
declare var screen:any;
declare var window:any;
@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav;
  rootPage:any = null;
  public app_css:any = ""
  //rootPage:any = ItemDetailComponent;


  constructor(platform: Platform,private _http:Http) {


    platform.ready().then(() => {
this.nav.setRoot('home');
// if(window.orientation){
// let rotate:any = 0 - window.orientation;
// this.app_css = "transform:rotate("+rotate+"deg)";
// }
    });


  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts